/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBellPlus: {
  name: 'bell-plus';
  data: string;
} = {
  name: 'bell-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5A5.5 5.5 0 0 0 2.5 6v4.764a.5.5 0 0 1-.053.224l-.894 1.788A.5.5 0 0 0 2 13.5h3.55a2.5 2.5 0 0 0 4.9 0H14a.5.5 0 0 0 .447-.724l-.894-1.788a.5.5 0 0 1-.053-.224V6A5.5 5.5 0 0 0 8 .5Zm2 12h3.191l-.533-1.065a1.499 1.499 0 0 1-.158-.671V6a4.5 4.5 0 1 0-9 0v4.764a1.5 1.5 0 0 1-.158.67L2.809 12.5H10Zm-3.415 1h2.83a1.5 1.5 0 0 1-2.83 0ZM8.5 5a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V9a.5.5 0 0 0 1 0V7.5H10a.5.5 0 0 0 0-1H8.5V5Z" fill="currentColor"/></svg>`,
};
